/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportingExaminationPreviewRequestDto
 */
export interface SupportingExaminationPreviewRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SupportingExaminationPreviewRequestDto
     */
    harmfulFactorIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupportingExaminationPreviewRequestDto
     */
    articleIds: Array<string>;
}

/**
 * Check if a given object implements the SupportingExaminationPreviewRequestDto interface.
 */
export function instanceOfSupportingExaminationPreviewRequestDto(value: object): value is SupportingExaminationPreviewRequestDto {
    if (!('harmfulFactorIds' in value) || value['harmfulFactorIds'] === undefined) return false;
    if (!('articleIds' in value) || value['articleIds'] === undefined) return false;
    return true;
}

export function SupportingExaminationPreviewRequestDtoFromJSON(json: any): SupportingExaminationPreviewRequestDto {
    return SupportingExaminationPreviewRequestDtoFromJSONTyped(json, false);
}

export function SupportingExaminationPreviewRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportingExaminationPreviewRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'harmfulFactorIds': json['harmfulFactorIds'],
        'articleIds': json['articleIds'],
    };
}

export function SupportingExaminationPreviewRequestDtoToJSON(value?: SupportingExaminationPreviewRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'harmfulFactorIds': value['harmfulFactorIds'],
        'articleIds': value['articleIds'],
    };
}

